import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from "@mui/material";
import { forwardRef } from "react";
export const UiAvatar = forwardRef((props, ref) => (_jsx(Avatar, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_avatar.js.map